module.exports = __webpack_public_path__ + "702772653fc3bed30c9a885785f9cc36.svg";